export enum DialogType {
    Error = 'error',
    Info = 'info',
    Question = 'question',
    Success = 'success',
    Warning = 'warning',
}

export enum EmailType {
    Email = 0,
    Fax = 1,
}
